import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');
  const router = inject(Router);

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        // Only handle 401 if we had a token (authenticated request failed)
        // Don't redirect if there was no token to begin with (unauthenticated state)
        if (token) {
          console.warn('[TokenInterceptor] 401 Unauthorized - token invalid or expired');
          localStorage.removeItem('token');
          // Only navigate if not already on login page
          if (!router.url.includes('/login')) {
            router.navigate(['/login']);
          }
        }
      }
      return throwError(() => error);
    })
  );
};
